import { config } from '@services/config';
import { InsuredLocationMetadataGetResponse } from '@lio/api-types';
import { customerQueryKey } from '@services/customer/keys';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useInsuredLocationMetadata = (customerId?: string) => {
  const client = useClient();
  const result = useQuery<InsuredLocationMetadataGetResponse>({
    queryKey: customerQueryKey.getLocationMetadata({ customerId }),
    queryFn: () =>
      client.get(`customer/${customerId}/insured-location/metadata`).json<InsuredLocationMetadataGetResponse>(),
    enabled: !!customerId,
    ...config,
  });
  return { ...result, insuredLocationsMetadata: result.data };
};
